module.exports = __webpack_public_path__ + "img/w-service.2fb80974.svg";